import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
var getActiveSlt = function getActiveSlt() {
  return function (sltState) {
    var activeSltId = sltState.meta.activeSltId;
    if (!activeSltId) return null;
    return sltState[activeSltId] || null;
  };
};
export default createMemoizedSelector(getActiveSlt);